import { get } from "lodash"

const EMPTY_ARRAY = []

export const getRecentInstruments = state => get(state, "app.recentInstruments", EMPTY_ARRAY)
